import { isSection } from '../../products';
import { hasRoomSlots } from '../common';
import { translate } from '../../L10n';
import { t } from '../../../translations';
import tacHelpers from '../../../state/tac/tacHelpers';
import { ceil } from '../../../util/round';
import productService from '../../products';

function shouldDisplayProductType(product) {
  return !isSection(product);
}

function getDisabledStatus(tac, product, space, rebased) {
  if (isSection(product)) {
    if (hasRoomSlots(tac, space, product)) {
      const xMargin = tacHelpers.getXmargin({
        ...tac,
        items: tac.items.filter(item =>
          productService.isType(item, 'mounting-rail')
        ),
      });

      const singleRailWidth = 650;
      const savedWidthOnMerge = 50;

      if (xMargin >= singleRailWidth) {
        // if the xMargin is above or equal to the width of the 'single' mounting rail, we can always fit
        return false;
      } else if (
        xMargin +
          savedWidthOnMerge *
            ceil(
              tac.items.filter(
                item =>
                  productService.isType(item, 'mounting-rail') &&
                  item.width === singleRailWidth
              ).length / 2,
              1
            ) >=
        singleRailWidth
      ) {
        // if the xMargin is below 650 we could still fit,
        // but only if there are enough 'single' rails on the scene
        // that the merges would free up the space needed
        return false;
      }
      return translate(t.POPUP_ALERT_SUSPENSION_RAIL);
    }
    return translate(t.BALLOON_HINT_NO_PLACE);
  }

  const hasOpenConnectionSlot = tacHelpers.hasOpenSlot(tac, product, rebased);
  if (!hasOpenConnectionSlot) {
    return translate(t.BALLOON_HINT_NO_PLACE);
  }

  return false;
}

function displayColor(product) {
  return isSection(product);
}

const getSceneInitFunctions = () => [];

export default {
  shouldDisplayProductType,
  getDisabledStatus,
  displayColor,
  getSceneInitFunctions,
};
